export enum SearchState {
  Inactive,
  Searching,
  HasResults,
  HasNoResults
}
